import { ErrorMessage, Field } from "formik";
import React, { memo } from "react";
import ErrorMsg from "./ErrorMsg";
const TextAreaField = ({
  type,
  name,
  id,
  label,
  className,
  children,
  ...rest
}) => {
  return (
    <div className="form-group mb-4 relative">
      {label && (
        <label htmlFor={id} className="block  text-sm md:text-[1rem] mb-2">
          {label}:
        </label>
      )}
      <div className="relative">
        <Field name={name} as={type} id={id}>
          {({ field }) => (
            <textarea
              value={field.value}
              onChange={field.onChange}
              name={name}
              id={id}
              {...rest}
              className={`p-2 relative w-full  border rounded-xl transition-all  focus:border-third-color shadow-sm outline-none border-light-color ${className}`}
            />
          )}
        </Field>
        {children}
      </div>
      <ErrorMessage name={name} component={ErrorMsg} />
    </div>
  );
};

export default memo(TextAreaField);
